export const dc_lang = {
  music: '国内版(CHN)',
  奖金池: 'The prize',
  可参与: 'Participable',
  可参赛: 'Participable',
  进行中: 'In  progress',
  创意赛: 'Originality',
  主办方: 'The Organizer',
  当前阶段:'Stage',
  参赛队伍:'Teams',
  参赛人数:'Participants',
  作品提交数:'Submissions',
  竞赛信息:'Competition requirement',
  赛事动态:'Match News',
  任务与数据:'The Challenge',
  竞赛圈:'Discussion',
  排行榜:'Ranking list',
  参赛人员:'Participants',
  参赛团队:'Teams',
  竞赛背景:'Competition background',
  奖项:'Awards',
  时间安排:'Time schedule',
  参赛与组队规则:'Who can enter',
  '所有参赛人员及队伍，视为已同意':"The captain is responsible for the team member, who is agree with the",
  '《DC竞赛作弊管理规则》':"< DC competition's cheating management regulations >",
  '及其他相关规定。队长对其队员的参赛行为负责。':"and the other pertinent rules.",
  '团队人数上限5人' :'The team must be built from 1 people minimum to 5 people',

  登录:'Log in',
  账号:'Account',
  '请输入用户名/邮箱/手机号':'User Name/Email/Phone Number',
  密码:'Password',
  输入密码:'Enter the password',
  立即注册:'Register now',
  忘记密码:'Forget the Password',
  快捷登录:'Quick login',

  手机找回密码:'Retrieve password by phone number',
  使用手机找回:'Retrieve password by phone number',
  请输入手机号码:'Please enter your mobile phone number',
  验证码:'Code',
  获取验证码: 'Send',
  输入验证码: 'Enter code',
  '新密码（5-16位）':'New password (5-16 bits)',
  '5-16位密码':'5-16 bits password',
  确认:'Yes',
  使用邮箱找回:'Retrieve password by email',
  邮箱找回密码:'Retrieve password by email',
  邮箱地址:'Email',

  手机号:'Phone',
  请输入手机号:'Enter phone number',
  用户名:'UserName',
  设置用户名称:'Set user name',
  '注册即表示你已同意':'You have agreed',
  '《DC服务规则》':'<the DC service rules>',
  '已有账户？':'Already have an account?',
  立即登录:'Login immediately',
  邮箱注册:'Register via email',
  邮箱:'Email',

  团队概况:'Team',
  团队名称:'The name of the team',
  团队介绍:'Team introduction',
  暂无介绍:'No information',
  最终排名:'The ranking',
  '未公布/未上榜':'Not published/not on the list',
  团队成员:'The team members',
  组队情况:'Team building',
  组队状态:'Team state',
  开放组队:'StateOpened',
  关闭组队:'StateClosed',
  组队邀请:'Invitation',
  暂无:'No information',
  需要队友:'TeammateNeeded',
  需要技能:'Skills Needed',

  当前成员:'Current member',
  在职:'Staff',
  暂无荣誉:'No honor',
  队长:'The captain',

  先聊一下:'Chat',
  申请组队:'Join the team',
  查看全部参赛队伍:'All teams',

  关注:'Favors',
  粉丝:'Fans',
  个人:'Information',
  竞赛:'Competition',
  成就: 'My Achievement',
  名人堂积分:'Integration',
  名人堂排名:'Personal Rankings',
  性别:'Sexy',
  学历:'Diploma',
  学校:'School',
  专业:'Major',
  角色:'Role',
  技能:'Skills',

  已得分提交次数:'Number of submissions',
  最近提交时间:'Latest submission time',
  请至DC竞赛PC端提交结果:'Please submit the results through thewebsite',
  暂无内容:'No information',

  温馨提示:'Tips',
  '暂不支持下载数据，请至DC竞赛PC端下载。':'Download the data on the website.',
  好的:' Yes',

  'DC竞赛-大数据竞赛平台':'DC competition-Big data competition platform',
  算法赛:'Algorithm',
  竞赛已结束:'Competition finished',
  '你可以报名参赛，并提交得到排名，但不会获得实物奖励。':"You can paticipate and submit your ranking, but you won't be Rewarded.",
  报名参赛:'paticipate',
  任务:'Task',
  数据:'Data',
  '备注：报名参赛或加入队伍后，可获取数据下载权限。':'Note ：You can download the data after entering the competition or joining in a team.',
  暂无角色:'Role Unknown',
  角色未知:'Role Unknown',
  暂无技能:'SkillsUnknown',
  技能未知:'SkillsUnknown',
  你猜:'Unknown',
  博士及以上:'Doctor',
  大专及同等学历:'Junoir College',
  '硕士/研究生':'Master',
  '本科/学士':'Bachelor',

  其他:'Others',
  参加竞赛:'paticipate the competition',
  可参加:'Available',
  得分:'Score',
  暂无成绩:'No score',
  排名:'Ranking',
  获得成就:'Achievement',
  名次:'Ranking',
  奖励:'The prize',

  '竞赛已结束，无法加入其他队伍，仅可自己创建队伍':'The competition is finished. You can only create your own team',
  创建队伍:'Create my team',
  没有登录:'Not logged in',
  去登录:'Sign in',
  没有更多了:'No more',
  赞:'Like',
  条评论:' response',
  大声说出你的想法吧:'my opinion',
  发送:'Send',
  回复:'reply',

  邀请赛:'invitation competition',
  专题赛:'project competition',
  全部:'all',
  已结束:'finished',

}



//////////////////
// WEBPACK FOOTER
// ./static/js/lang/en.js
// module id = 88YI
// module chunks = 55